import { AgencyUsersList } from '@anytag/shared-organisms';
import { useAgencyDetailsContext } from './agency-details-context';

export const AgencyUsers = () => {
  const { agency } = useAgencyDetailsContext();

  return <AgencyUsersList agencyId={agency.id} />;
};
